import BScroll from "better-scroll";
import tools from "../../utils/fun";
import dataConfig from "../../baseConfig/dataConfig";
import httpConfig from "../../baseConfig/httpConfig";

export default function RummyHomeTools(self) {
    this._self = self;
    this._scroll = null;
};

/**
 * 设置参数重新调整
 */
RummyHomeTools.prototype.resetScroll = function (num) {
    let width = (2.81 + 0.2) * num;
    if (this._self.$refs.refGameContainer) {
        this._self.$refs.refGameContainer.style.width = width + "rem";
        if (this._scroll) {
            this._scroll.refresh();
        }
    }
};

/**
 * 初始化游戏列表
 */
RummyHomeTools.prototype.initGameListScroll = function () {
    if (!this._self.$refs && !this._self.$refs.wrapper) {
        return;
    };
    if (this._scroll) {
        this._scroll.refresh();
    } else {
        let params = {
            startX: 0,
            scrollX: true,
            scrollY: false,
            probeType: 1,
            //1 滚动的时候会派发scroll事件，会截流。2滚动的时候实时派发scroll事件，不会截流。 3除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
            click: true,
            momentum: true, //当快速滑动时是否开启滑动惯性
            bounce: true, //是否启用回弹动画效果
        };
        this._scroll = new BScroll(this._self.$refs.wrapper, params);
    }
}

RummyHomeTools.prototype.getGameList = function () {
    let rlt = [];
    let cn = this._self.$store.getters["common/getChannel"];

    let repStr1 = "game";

    let repStr2 = "game";
    if (dataConfig.fullGameChannels.indexOf(cn) != -1)
        repStr2 = "game2";
    rlt.push({
        img: dataConfig.rummyConfig.common["2Player"].img.replace(repStr1, repStr2),
        key: "common_2Player"
    });
    rlt.push({
        img: dataConfig.rummyConfig.common["6Player"].img.replace(repStr1, repStr2),
        key: "common_6Player"
    });
    rlt.push({
        img: dataConfig.rummyConfig.pool.img.replace(repStr1, repStr2),
        key: "pool"
    });
    let channel = cn;
    if (dataConfig.fullGameChannels.indexOf(channel) != -1) {
        rlt.push({
            img: dataConfig.rummyConfig.teenptti.img.replace(repStr1, repStr2),
            key: "teenptti"
        });
    };
    rlt.push({
        img: dataConfig.rummyConfig.soon.img,
        key: null
    });
    for (let index in rlt) {
        rlt[index].img = tools.changeTowebp(rlt[index].img);
    }
    return rlt;
}



// WEBPACK FOOTER //
// ./src/components/home/rummy_home_tools.js